export const qaLabelModals = {
    closeButton: 'modal--close-button',
    // TO DO: Deprecate
    toastMessage: 'toast-message',
    // Modal.tsx class
    modalCancelButton: 'modal--cancel-button',
    modalOkButton: 'modal--ok-button',
    modalTitle: 'modal-title',
    modalParagraph: 'modal-paragraph',
    tabsList: 'tabs-list',
    tabItem: 'tab-item',
};
export const qaLabelCommon = {
    toastText: 'toast-message-text',
    dropdownFirstOption: '[id*="-option-0"]',
    classControl: '[class$=-control]',
    reactSelectOptions: '[id^=react-select]'
};
